(() => {
  const initializeCart = (cart) => {
    if (!cart || cart.dataset.riverCartInitialized === 'true') return;

    cart.dataset.riverCartInitialized = 'true';
    const changeUrl = cart.dataset.cartChangeUrl;

    cart.addEventListener('click', async (event) => {
      const button = event.target.closest('[data-river-cart-quantity-button]');
      if (!button || !cart.contains(button) || !changeUrl) return;

      const control = button.closest('[data-river-cart-quantity-control]');
      const errorMessage = control?.querySelector(
        '[data-river-cart-quantity-error]'
      );
      const buttons =
        control?.querySelectorAll('[data-river-cart-quantity-button]') || [];

      errorMessage?.classList.add('hidden');
      if (errorMessage) errorMessage.textContent = '';
      buttons.forEach((quantityButton) => {
        quantityButton.disabled = true;
      });
      control?.setAttribute('aria-busy', 'true');

      try {
        const response = await fetch(changeUrl, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            Accept: 'application/json',
          },
          body: JSON.stringify({
            line: Number(button.dataset.line),
            quantity: Number(button.dataset.quantity),
          }),
        });
        const result = await response.json().catch(() => ({}));

        if (!response.ok) {
          throw new Error(
            result.description ||
              result.message ||
              'Unable to update this item quantity.'
          );
        }

        window.RiverAnalytics?.cartChanged(result);
        window.location.reload();
      } catch (error) {
        if (errorMessage) {
          errorMessage.textContent =
            error instanceof Error
              ? error.message
              : 'Unable to update this item quantity.';
          errorMessage.classList.remove('hidden');
        }
        buttons.forEach((quantityButton) => {
          quantityButton.disabled = false;
        });
        control?.removeAttribute('aria-busy');
      }
    });
  };

  const initializeCarts = (root = document) => {
    root.querySelectorAll('[data-river-cart]').forEach(initializeCart);
  };

  initializeCarts();
  document.addEventListener('shopify:section:load', (event) =>
    initializeCarts(event.target)
  );
})();
